import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import consultaSlice from "./slices/consultaSlice";
import crearSlice  from "./slices/crearSlice";
import homeSlice from "./slices/homeSlice";
import authSlice from "./slices/authSlice";
import LiquidacionRutasSlice from "./slices/liquidacionRutasSlice"

//utilizamos esto para que la información de redux no se pierda cuando se recargue la página o cambiamos de pestaña, así los tiempos de espera son menores
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['home', 'auth']
};

//comprimimos todos los slice en uno solo 
export const reducers = combineReducers({
  crear: crearSlice,
  consulta: consultaSlice,
  home: homeSlice,
  auth: authSlice,
  liquidacionRutas: LiquidacionRutasSlice 
});


//declaramos el la configuración y el persistReducer
const persistedReducer = persistReducer(persistConfig, reducers);

//configuramos la store y en la información le ponemos el persisted reducer 
export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false,
  })
});


//declaramos los tipos de datos para usarlos libremente en nuestra aplicación 
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

//Modificamos los hooks de react para que funcionen correctamente con nuestra app 
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

